import { createFileRoute } from "@tanstack/react-router";
import { PartnerSignup } from "@/pages/partner-signup/PartnerSignup";

export const Route = createFileRoute("/partner/signup")({
	head: () => ({
		meta: [{ title: "Connect Partner Account" }],
	}),
	component: PartnerSignup,
});
